import React, {Component} from 'react';

import Fullscreen from "../../assets/img/icons/fullscreen.svg";
import ExitFullscreen from "../../assets/img/icons/fullscreen_close.svg";

export default class ToggleFullscreen extends Component {
  constructor(props) {
    super(props);
    this.state = { fullscreen: false };
    this.toggleScreen = this.toggleScreen.bind(this);
    this.handleEsc= this.handleEsc.bind(this);
  }

  componentWillMount() {
    document.addEventListener('fullscreenchange', this.handleEsc);
    document.addEventListener('webkitfullscreenchange', this.handleEsc);
    document.addEventListener('mozfullscreenchange', this.handleEsc);
    document.addEventListener('MSFullscreenChange', this.handleEsc);
  }

  componentWillUnmount() {
    document.removeEventListener('fullscreenchange', this.handleEsc);
    document.removeEventListener('webkitfullscreenchange', this.handleEsc);
    document.removeEventListener('mozfullscreenchange', this.handleEsc);
    document.removeEventListener('MSFullscreenChange', this.handleEsc);
  }

  handleEsc() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      this.setState({
        fullscreen: !(false !== true)
      })
    }
  }

  toggleScreen() {
    const { state } = this;
    let elem = document.documentElement;

    if (state.fullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.setState({
        fullscreen: !state.fullscreen
      })

    } else {

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      this.setState({
        fullscreen: !state.fullscreen
      })
    }
  }

  render() {
    const { fullscreen } = this.state;
    return (
      <div className="toggle-fullscreen orange-circle-button" onClick={this.toggleScreen}>
        <img alt="viewType" src={(fullscreen) ? ExitFullscreen : Fullscreen}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ToggleFullscreen.js